import { Injectable, NgZone, OnDestroy } from "@angular/core";
import { BehaviorSubject, forkJoin, of, Subject } from "rxjs";
import { PastValueDetails } from "ng/src/app/notes/past-values/past-value-viewer/past-value-viewer.model";
import { NoteService } from "ng/src/app/notes/shared/note.service";
import { catchError, filter, map, switchMap, takeUntil } from "rxjs/operators";
import { TemplateService } from "ng/src/app/templates/shared/template.service";
import { HttpErrorResponse } from "@angular/common/http";
import { NoteProjections } from "app/shared/model/request-parameter.model";

@Injectable({ providedIn: 'root' })
export class PastValueViewerService implements OnDestroy {
	
	private readonly serviceUpdateSubject = new Subject<{note: number, segment: number, event: Event}>();
	pastValueSubject = new Subject<PastValueDetails>();
	isShowingPastValues = new BehaviorSubject<boolean>(false);
	
	constructor(
		noteService: NoteService,
		templateService: TemplateService,
		ngZone: NgZone
	) {
		(window as any).viewPastValue = (note: number, segment: number, event: Event) => {
			if (this.isShowingPastValues.value) {
				if (event.currentTarget && 'href' in event.currentTarget) {
					const href = (event.currentTarget as HTMLAnchorElement).href;
					window.open(href, '_blank');
					event.preventDefault();
				}
				return;
			}
			event.preventDefault();
			ngZone.run(() => this.showFromIds(note, segment, event));
		}
		
		this.serviceUpdateSubject.pipe(
			takeUntil(this.onDestroy$),
			switchMap(update =>
				forkJoin({
					note: noteService.getLogNote(update.note, NoteProjections.BASE),
					segment: templateService.getTemplateSegment(update.segment)
				})
					.pipe(
						filter(res => !!res.segment && !!res.note),
						map(res => {
							return {
								note: res.note,
								segment: res.segment,
								event: update.event
							}
						}),
						catchError((err: Error | HttpErrorResponse) => {
							console.error(`${err.name} ${err.message}`);
							return of(null);
						})
					)
			),
				filter(res => res != null)
			)
			.subscribe(update => this.updateView(update!));
	}
	private readonly onDestroy$ = new Subject();
	
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	
	updateView(update: PastValueDetails) {
		this.pastValueSubject.next(update);
	}
	
	showFromIds(note: number, segment: number, event: Event) {
		this.serviceUpdateSubject.next({note, segment, event});
	}
}